/**
 * User Store
 * متجر إدارة المستخدمين
 */

import { makeAutoObservable } from 'mobx';
import api from '../services/api';

class UserStore {
  users = [];
  serviceProviders = [];
  loading = false;
  error = null;

  constructor() {
    makeAutoObservable(this);
  }

  async fetchUsers() {
    this.loading = true;
    this.error = null;
    
    try {
      const response = await api.api.get('/admin/users');
      if (response.data.status === 'success') {
        this.users = response.data.data || [];
      } else {
        this.error = response.data.message || 'فشل في تحميل المستخدمين';
      }
    } catch (error) {
      console.error('Error fetching users:', error);
      this.error = 'فشل في تحميل المستخدمين';
    } finally {
      this.loading = false;
    }
  }

  async fetchServiceProviders() {
    this.loading = true;
    this.error = null;
    
    try {
      const response = await api.api.get('/admin/users', {
        params: { role: 'service_provider' }
      });
      if (response.data.status === 'success') {
        this.serviceProviders = response.data.data || [];
      } else {
        this.error = response.data.message || 'فشل في تحميل مزودي الخدمة';
      }
    } catch (error) {
      console.error('Error fetching service providers:', error);
      this.error = 'فشل في تحميل مزودي الخدمة';
    } finally {
      this.loading = false;
    }
  }

  getUserById(id) {
    return this.users.find(user => user.id === id);
  }

  getServiceProviderById(id) {
    return this.serviceProviders.find(provider => provider.id === id);
  }

  getUsersByRole(role) {
    return this.users.filter(user => user.roles?.some(r => r.name === role));
  }

  getActiveUsers() {
    return this.users.filter(user => user.account_status === 'active');
  }

  getPremiumUsers() {
    return this.users.filter(user => user.account_status === 'premium');
  }
}

export const userStore = new UserStore();
